import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldOff } from "lucide-react";
import api from "../lib/api";

export default function BlockedAccounts() {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => { api.get("/blocks").then(r => setList(r.data)).catch(() => setList([])); }, []);

  const unblock = async (id) => {
    setBusy(id);
    try {
      await api.delete(`/users/${id}/block`);
      setList(l => l.filter(u => u.id !== id));
    } finally { setBusy(""); }
  };

  return (
    <div className="px-4 py-6" data-testid="blocked-accounts-page">
      <div className="flex items-center gap-3 mb-1">
        <Link to="/settings" data-testid="blocked-back"><ArrowLeft className="w-5 h-5"/></Link>
        <h1 className="font-outfit font-extrabold text-2xl tracking-tighter">Blocked Accounts</h1>
      </div>
      <p className="text-white/60 text-xs mb-5 ml-8">People you block can't message, follow or comment on your reels.</p>

      {list === null ? <p className="text-white/50 text-sm">Loading...</p> : list.length === 0 ? (
        <div className="p-8 rounded-3xl bg-white/5 border border-white/10 text-center" data-testid="blocked-empty">
          <ShieldOff className="w-8 h-8 mx-auto mb-2 text-white/30"/>
          <p className="text-sm text-white/60">You haven't blocked anyone.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="blocked-list">
          {list.map(u => (
            <div key={u.id} className="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/10" data-testid={`blocked-row-${u.id}`}>
              <Link to={`/u/${u.id}`} className="flex items-center gap-3 flex-1 min-w-0">
                <img src={u.avatar || `https://api.dicebear.com/7.x/initials/svg?seed=${u.username || u.name}`} alt="" className="w-10 h-10 rounded-full object-cover bg-white/10"/>
                <div className="min-w-0">
                  <div className="font-semibold text-sm truncate">{u.name || u.username}</div>
                  <div className="text-[11px] text-white/50 truncate">@{u.username}</div>
                </div>
              </Link>
              <button onClick={()=>unblock(u.id)} disabled={busy === u.id} data-testid={`unblock-${u.id}`}
                className="px-4 py-2 rounded-full bg-[#00E5FF] text-black text-xs font-extrabold active:scale-95 disabled:opacity-50">
                {busy === u.id ? "..." : "Unblock"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
